import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Grid, 
  Card, 
  CardContent, 
  Divider, 
  TextField, 
  Button, 
  List, 
  ListItem, 
  ListItemText, 
  ListItemIcon,
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  InputAdornment,
  Chip,
  Avatar,
  IconButton,
  Tabs,
  Tab,
  Link,
  Alert,
  Snackbar
} from '@mui/material';
import { 
  ExpandMore as ExpandMoreIcon,
  Search as SearchIcon,
  QuestionAnswer as QuestionAnswerIcon,
  LiveHelp as LiveHelpIcon,
  School as SchoolIcon,
  VideoLibrary as VideoLibraryIcon,
  MenuBook as MenuBookIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Chat as ChatIcon,
  Headset as HeadsetIcon,
  Forum as ForumIcon,
  Assignment as AssignmentIcon,
  Lightbulb as LightbulbIcon,
  Send as SendIcon,
  Download as DownloadIcon,
  PlayArrow as PlayArrowIcon,
  Bookmark as BookmarkIcon,
  ThumbUp as ThumbUpIcon,
  ThumbDown as ThumbDownIcon
} from '@mui/icons-material';
import MainLayout from '../layout/MainLayout';

// Beispieldaten für FAQs
const faqData = [
  {
    category: 'Allgemein',
    questions: [
      {
        id: 'faq-1',
        question: 'Was ist ARGUS Health Data Platform?',
        answer: 'ARGUS ist eine sichere Plattform für den Zugriff auf und die Analyse von Gesundheitsdaten. Sie ermöglicht Forschern und medizinischen Fachkräften, Datenanfragen an Partnerkliniken zu stellen, während gleichzeitig höchste Datenschutz- und Sicherheitsstandards eingehalten werden.'
      },
      {
        id: 'faq-2',
        question: 'Wie kann ich mich bei ARGUS registrieren?',
        answer: 'Die Registrierung bei ARGUS erfolgt über Ihre Organisation. Bitte wenden Sie sich an Ihren Organisationsadministrator oder kontaktieren Sie unser Support-Team unter support@argus-platform.de, um Informationen zur Registrierung zu erhalten.'
      },
      {
        id: 'faq-3',
        question: 'Ist ARGUS DSGVO-konform?',
        answer: 'Ja, ARGUS wurde unter strikter Einhaltung der Datenschutz-Grundverordnung (DSGVO) entwickelt. Alle Daten werden verschlüsselt gespeichert und übertragen, und wir implementieren umfassende Maßnahmen zum Schutz personenbezogener Daten.'
      }
    ]
  },
  {
    category: 'Datenanfragen',
    questions: [
      {
        id: 'faq-4',
        question: 'Wie stelle ich eine neue Datenanfrage?',
        answer: 'Um eine neue Datenanfrage zu stellen, navigieren Sie zum Menüpunkt "Neue Datenanfrage". Dort können Sie Ihre Kohorte definieren, relevante Datenvariablen auswählen und einen Analyseplan erstellen. Folgen Sie den Anweisungen auf dem Bildschirm, um Ihre Anfrage einzureichen.'
      },
      {
        id: 'faq-5',
        question: 'Wie lange dauert die Bearbeitung einer Datenanfrage?',
        answer: 'Die Bearbeitungszeit variiert je nach Komplexität der Anfrage und Auslastung der Partnerklinik. In der Regel werden Anfragen innerhalb von 3-5 Werktagen geprüft. Nach der Genehmigung kann die Datenanalyse je nach Umfang weitere 1-7 Tage in Anspruch nehmen.'
      },
      {
        id: 'faq-6',
        question: 'Kann ich eine abgelehnte Anfrage erneut einreichen?',
        answer: 'Ja, Sie können eine abgelehnte Anfrage überarbeiten und erneut einreichen. Beachten Sie die Ablehnungsgründe und passen Sie Ihre Anfrage entsprechend an. Nutzen Sie den Chat, um mit der Partnerklinik zu kommunizieren und Ihre Anfrage zu optimieren.'
      }
    ]
  },
  {
    category: 'Datenanalyse',
    questions: [
      {
        id: 'faq-7',
        question: 'Welche Analysemethoden stehen zur Verfügung?',
        answer: 'ARGUS bietet verschiedene Analysemethoden, darunter deskriptive Statistik, Korrelationsanalysen, Regressionsanalysen, Überlebenszeitanalysen und Clusteranalysen. Die verfügbaren Methoden können je nach Partnerklinik und Datensatz variieren.'
      },
      {
        id: 'faq-8',
        question: 'Kann ich eigene Analyseskripte verwenden?',
        answer: 'Ja, in bestimmten Fällen können Sie eigene Analyseskripte in R oder Python hochladen. Diese werden vor der Ausführung von der Partnerklinik geprüft, um die Datensicherheit zu gewährleisten. Bitte beachten Sie die Richtlinien für benutzerdefinierte Skripte in unserer Dokumentation.'
      },
      {
        id: 'faq-9',
        question: 'Wie kann ich die Analyseergebnisse exportieren?',
        answer: 'Analyseergebnisse können in verschiedenen Formaten exportiert werden, darunter CSV, Excel, PDF und JSON. Navigieren Sie zur Ergebnisseite Ihrer Anfrage und klicken Sie auf "Ergebnisse herunterladen", um das gewünschte Format auszuwählen.'
      }
    ]
  },
  {
    category: 'Abrechnung',
    questions: [
      {
        id: 'faq-10',
        question: 'Wie werden die Kosten für Datenanfragen berechnet?',
        answer: 'Die Kosten für Datenanfragen basieren auf verschiedenen Faktoren, darunter die Komplexität der Anfrage, die Anzahl der angeforderten Variablen und der Umfang der Analyse. Ein Kostenvoranschlag wird Ihnen nach der ersten Prüfung Ihrer Anfrage mitgeteilt.'
      },
      {
        id: 'faq-11',
        question: 'Welche Zahlungsmethoden werden akzeptiert?',
        answer: 'ARGUS akzeptiert verschiedene Zahlungsmethoden, darunter Kreditkarten, Banküberweisung und in einigen Fällen auch Rechnungsstellung. Die verfügbaren Zahlungsmethoden können in den Abrechnungseinstellungen eingesehen werden.'
      },
      {
        id: 'faq-12',
        question: 'Gibt es Rabatte für akademische Einrichtungen?',
        answer: 'Ja, für akademische Einrichtungen und Forschungsinstitute bieten wir spezielle Tarife an. Bitte kontaktieren Sie unser Vertriebsteam unter sales@argus-platform.de, um mehr über unsere akademischen Rabatte zu erfahren.'
      }
    ]
  }
];

// Beispieldaten für Tutorials
const tutorialData = [
  {
    id: 'tut-1',
    title: 'Erste Schritte mit ARGUS',
    description: 'Lernen Sie die Grundlagen der ARGUS-Plattform kennen und erfahren Sie, wie Sie Ihr Konto einrichten.',
    type: 'video',
    duration: '5:30',
    url: '#',
    thumbnail: 'https://via.placeholder.com/300x180'
  },
  {
    id: 'tut-2',
    title: 'Kohortendefinition erstellen',
    description: 'Erfahren Sie, wie Sie effektive Kohortendefinitionen erstellen, um genau die Patientendaten zu erhalten, die Sie benötigen.',
    type: 'article',
    readTime: '8 min',
    url: '#',
    thumbnail: 'https://via.placeholder.com/300x180'
  },
  {
    id: 'tut-3',
    title: 'Fortgeschrittene Datenanalyse',
    description: 'Entdecken Sie die erweiterten Analysefunktionen von ARGUS und wie Sie aussagekräftige Erkenntnisse gewinnen können.',
    type: 'webinar',
    duration: '45:00',
    url: '#',
    thumbnail: 'https://via.placeholder.com/300x180'
  },
  {
    id: 'tut-4',
    title: 'Ergebnisse interpretieren und exportieren',
    description: 'Lernen Sie, wie Sie Analyseergebnisse interpretieren und in verschiedenen Formaten exportieren können.',
    type: 'article',
    readTime: '12 min',
    url: '#',
    thumbnail: 'https://via.placeholder.com/300x180'
  },
  {
    id: 'tut-5',
    title: 'Datenschutz und Compliance',
    description: 'Verstehen Sie die Datenschutz- und Compliance-Funktionen von ARGUS und wie Sie sicher mit sensiblen Gesundheitsdaten umgehen.',
    type: 'video',
    duration: '10:15',
    url: '#',
    thumbnail: 'https://via.placeholder.com/300x180'
  },
  {
    id: 'tut-6',
    title: 'Teamkollaboration in ARGUS',
    description: 'Erfahren Sie, wie Sie effektiv mit Ihrem Team in ARGUS zusammenarbeiten und Projekte gemeinsam verwalten können.',
    type: 'webinar',
    duration: '30:00',
    url: '#',
    thumbnail: 'https://via.placeholder.com/300x180'
  }
];

// Beispieldaten für Support-Kontakte
const supportContacts = [
  {
    title: 'E-Mail Support',
    description: 'Senden Sie uns eine E-Mail und erhalten Sie innerhalb von 24 Stunden eine Antwort.',
    icon: <EmailIcon fontSize="large" />,
    contact: 'support@argus-platform.de',
    action: 'E-Mail senden',
    url: 'mailto:support@argus-platform.de'
  },
  {
    title: 'Telefon-Hotline',
    description: 'Sprechen Sie direkt mit unserem Support-Team während der Geschäftszeiten (Mo-Fr, 9-17 Uhr).',
    icon: <PhoneIcon fontSize="large" />,
    contact: '+49 30 123456789',
    action: 'Anrufen',
    url: 'tel:+4930123456789'
  },
  {
    title: 'Live-Chat',
    description: 'Chatten Sie in Echtzeit mit unserem Support-Team für schnelle Hilfe bei dringenden Fragen.',
    icon: <ChatIcon fontSize="large" />,
    contact: 'Verfügbar während der Geschäftszeiten',
    action: 'Chat starten',
    url: '#'
  },
  {
    title: 'Community-Forum',
    description: 'Tauschen Sie sich mit anderen ARGUS-Nutzern aus und finden Sie Antworten auf häufig gestellte Fragen.',
    icon: <ForumIcon fontSize="large" />,
    contact: 'forum.argus-platform.de',
    action: 'Forum besuchen',
    url: '#'
  }
];

// Beispieldaten für Dokumentation
const documentationData = [
  {
    title: 'Benutzerhandbuch',
    description: 'Umfassende Anleitung zur Nutzung aller Funktionen der ARGUS-Plattform.',
    icon: <MenuBookIcon />,
    url: '#',
    format: 'PDF',
    size: '4.2 MB'
  },
  {
    title: 'API-Dokumentation',
    description: 'Technische Dokumentation für Entwickler zur Integration mit der ARGUS-API.',
    icon: <AssignmentIcon />,
    url: '#',
    format: 'HTML',
    size: 'Online'
  },
  {
    title: 'Datenschutzrichtlinien',
    description: 'Detaillierte Informationen zu unseren Datenschutzmaßnahmen und DSGVO-Compliance.',
    icon: <AssignmentIcon />,
    url: '#',
    format: 'PDF',
    size: '1.8 MB'
  },
  {
    title: 'Schnellstartanleitung',
    description: 'Kurze Anleitung für einen schnellen Einstieg in die ARGUS-Plattform.',
    icon: <LightbulbIcon />,
    url: '#',
    format: 'PDF',
    size: '1.2 MB'
  }
];

const HelpSupportPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [expandedFaq, setExpandedFaq] = useState(false);
  const [ticketSubject, setTicketSubject] = useState('');
  const [ticketMessage, setTicketMessage] = useState('');
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  
  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  
  const handleFaqChange = (panel) => (event, isExpanded) => {
    setExpandedFaq(isExpanded ? panel : false);
  };
  
  const handleTicketSubmit = (e) => {
    e.preventDefault();
    // Hier würde in einer realen Anwendung das Ticket gesendet werden
    console.log('Ticket submitted:', { subject: ticketSubject, message: ticketMessage });
    setTicketSubject('');
    setTicketMessage('');
    setSnackbarOpen(true);
  };
  
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  
  // Filtern der FAQs basierend auf dem Suchbegriff
  const filteredFaqs = faqData.map(category => ({
    ...category,
    questions: category.questions.filter(q => 
      q.question.toLowerCase().includes(searchTerm.toLowerCase()) || 
      q.answer.toLowerCase().includes(searchTerm.toLowerCase())
    )
  })).filter(category => category.questions.length > 0);
  
  return (
    <MainLayout>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 700, color: 'text.primary' }}>
          Hilfe & Support
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Finden Sie Antworten auf Ihre Fragen und erhalten Sie Unterstützung bei der Nutzung der ARGUS-Plattform.
        </Typography>
        
        <Paper sx={{ mb: 3 }}>
          <Tabs 
            value={activeTab} 
            onChange={handleTabChange} 
            aria-label="help tabs"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ 
              borderBottom: 1, 
              borderColor: 'divider',
              '& .MuiTab-root': {
                minHeight: 64,
                py: 2
              }
            }}
          >
            <Tab 
              icon={<QuestionAnswerIcon />} 
              label="FAQ" 
              iconPosition="start"
              sx={{ textTransform: 'none' }}
            />
            <Tab 
              icon={<SchoolIcon />} 
              label="Tutorials" 
              iconPosition="start"
              sx={{ textTransform: 'none' }}
            />
            <Tab 
              icon={<HeadsetIcon />} 
              label="Support kontaktieren" 
              iconPosition="start"
              sx={{ textTransform: 'none' }}
            />
            <Tab 
              icon={<MenuBookIcon />} 
              label="Dokumentation" 
              iconPosition="start"
              sx={{ textTransform: 'none' }}
            />
          </Tabs>
          
          <Box sx={{ p: 3 }}>
            {/* FAQ-Bereich */}
            {activeTab === 0 && (
              <Box>
                <TextField
                  fullWidth
                  placeholder="Suchen Sie nach Fragen oder Stichwörtern..."
                  variant="outlined"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{ mb: 3 }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                
                {filteredFaqs.length > 0 ? (
                  filteredFaqs.map((category, index) => (
                    <Box key={index} sx={{ mb: 4 }}>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, color: 'primary.main' }}>
                        {category.category}
                      </Typography>
                      <Divider sx={{ mb: 2 }} />
                      
                      {category.questions.map((faq) => (
                        <Accordion 
                          key={faq.id} 
                          expanded={expandedFaq === faq.id} 
                          onChange={handleFaqChange(faq.id)}
                          sx={{ 
                            mb: 1,
                            boxShadow: 'none',
                            border: '1px solid',
                            borderColor: 'divider',
                            '&:before': {
                              display: 'none',
                            },
                            '&.Mui-expanded': {
                              borderColor: 'primary.light',
                              bgcolor: 'rgba(255, 122, 0, 0.03)',
                            }
                          }}
                        >
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls={`${faq.id}-content`}
                            id={`${faq.id}-header`}
                            sx={{ 
                              '& .MuiAccordionSummary-content': {
                                display: 'flex',
                                alignItems: 'center',
                              }
                            }}
                          >
                            <LiveHelpIcon sx={{ mr: 2, color: 'primary.main' }} />
                            <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                              {faq.question}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails sx={{ pl: 6 }}>
                            <Typography variant="body1" paragraph>
                              {faq.answer}
                            </Typography>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                              <Button 
                                size="small" 
                                startIcon={<ThumbUpIcon />}
                                sx={{ color: 'success.main' }}
                              >
                                Hilfreich
                              </Button>
                              <Button 
                                size="small" 
                                startIcon={<ThumbDownIcon />}
                                sx={{ color: 'text.secondary' }}
                              >
                                Nicht hilfreich
                              </Button>
                            </Box>
                          </AccordionDetails>
                        </Accordion>
                      ))}
                    </Box>
                  ))
                ) : (
                  <Box sx={{ textAlign: 'center', py: 4 }}>
                    <Typography variant="h6" color="text.secondary" gutterBottom>
                      Keine Ergebnisse gefunden
                    </Typography>
                    <Typography variant="body1" color="text.secondary">
                      Versuchen Sie es mit anderen Suchbegriffen oder kontaktieren Sie unseren Support.
                    </Typography>
                    <Button 
                      variant="contained" 
                      color="primary" 
                      sx={{ mt: 2 }}
                      onClick={() => setActiveTab(2)}
                    >
                      Support kontaktieren
                    </Button>
                  </Box>
                )}
              </Box>
            )}
            
            {/* Tutorials-Bereich */}
            {activeTab === 1 && (
              <Box>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  Lernmaterialien und Tutorials
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                  Entdecken Sie unsere Sammlung von Tutorials, Videos und Artikeln, um das Beste aus der ARGUS-Plattform herauszuholen.
                </Typography>
                
                <Grid container spacing={3}>
                  {tutorialData.map((tutorial) => (
                    <Grid item xs={12} sm={6} md={4} key={tutorial.id}>
                      <Card 
                        variant="outlined" 
                        sx={{ 
                          height: '100%', 
                          display: 'flex', 
                          flexDirection: 'column',
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 3
                          }
                        }}
                      >
                        <Box 
                          sx={{ 
                            position: 'relative',
                            height: 180,
                            backgroundImage: `url(${tutorial.thumbnail})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center'
                          }}
                        >
                          {tutorial.type === 'video' && (
                            <IconButton 
                              sx={{ 
                                position: 'absolute', 
                                top: '50%', 
                                left: '50%', 
                                transform: 'translate(-50%, -50%)',
                                bgcolor: 'rgba(255, 255, 255, 0.8)',
                                '&:hover': {
                                  bgcolor: 'white'
                                }
                              }}
                            >
                              <PlayArrowIcon fontSize="large" color="primary" />
                            </IconButton>
                          )}
                          <Chip 
                            label={tutorial.type === 'video' ? `Video • ${tutorial.duration}` : 
                                  tutorial.type === 'article' ? `Artikel • ${tutorial.readTime} Lesezeit` : 
                                  `Webinar • ${tutorial.duration}`}
                            sx={{ 
                              position: 'absolute', 
                              bottom: 8, 
                              right: 8,
                              bgcolor: 'rgba(255, 255, 255, 0.9)'
                            }}
                            size="small"
                            icon={tutorial.type === 'video' ? <VideoLibraryIcon /> : 
                                 tutorial.type === 'article' ? <MenuBookIcon /> : 
                                 <SchoolIcon />}
                          />
                        </Box>
                        <CardContent sx={{ flexGrow: 1 }}>
                          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                            {tutorial.title}
                          </Typography>
                          <Typography variant="body2" color="text.secondary" paragraph>
                            {tutorial.description}
                          </Typography>
                        </CardContent>
                        <Box sx={{ p: 2, pt: 0, display: 'flex', justifyContent: 'space-between' }}>
                          <Button 
                            variant="text" 
                            color="primary" 
                            startIcon={tutorial.type === 'video' ? <PlayArrowIcon /> : <MenuBookIcon />}
                            href={tutorial.url}
                          >
                            {tutorial.type === 'video' ? 'Ansehen' : 
                             tutorial.type === 'article' ? 'Lesen' : 
                             'Teilnehmen'}
                          </Button>
                          <IconButton color="primary">
                            <BookmarkIcon />
                          </IconButton>
                        </Box>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )}
            
            {/* Support-Kontakt-Bereich */}
            {activeTab === 2 && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    Support-Optionen
                  </Typography>
                  <Typography variant="body1" paragraph color="text.secondary">
                    Wählen Sie aus verschiedenen Möglichkeiten, um mit unserem Support-Team in Kontakt zu treten.
                  </Typography>
                  
                  <Grid container spacing={2}>
                    {supportContacts.map((contact, index) => (
                      <Grid item xs={12} sm={6} key={index}>
                        <Card variant="outlined" sx={{ height: '100%' }}>
                          <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <Avatar sx={{ bgcolor: 'primary.light', mr: 2 }}>
                                {contact.icon}
                              </Avatar>
                              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                {contact.title}
                              </Typography>
                            </Box>
                            <Typography variant="body2" color="text.secondary" paragraph>
                              {contact.description}
                            </Typography>
                            <Typography variant="body1" gutterBottom sx={{ fontWeight: 500 }}>
                              {contact.contact}
                            </Typography>
                            <Button 
                              variant="outlined" 
                              color="primary" 
                              fullWidth
                              href={contact.url}
                              sx={{ mt: 1 }}
                            >
                              {contact.action}
                            </Button>
                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                </Grid>
                
                <Grid item xs={12} md={6}>
                  <Card variant="outlined">
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        Support-Ticket erstellen
                      </Typography>
                      <Typography variant="body2" color="text.secondary" paragraph>
                        Beschreiben Sie Ihr Anliegen, und unser Support-Team wird sich innerhalb von 24 Stunden bei Ihnen melden.
                      </Typography>
                      
                      <form onSubmit={handleTicketSubmit}>
                        <TextField
                          fullWidth
                          label="Betreff"
                          variant="outlined"
                          margin="normal"
                          required
                          value={ticketSubject}
                          onChange={(e) => setTicketSubject(e.target.value)}
                        />
                        <TextField
                          fullWidth
                          label="Beschreibung"
                          variant="outlined"
                          margin="normal"
                          required
                          multiline
                          rows={6}
                          value={ticketMessage}
                          onChange={(e) => setTicketMessage(e.target.value)}
                          placeholder="Beschreiben Sie Ihr Problem oder Ihre Frage so detailliert wie möglich..."
                        />
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                          <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            startIcon={<SendIcon />}
                            disabled={!ticketSubject.trim() || !ticketMessage.trim()}
                          >
                            Ticket senden
                          </Button>
                        </Box>
                      </form>
                    </CardContent>
                  </Card>
                  
                  <Card variant="outlined" sx={{ mt: 3 }}>
                    <CardContent>
                      <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                        Geschäftszeiten
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Montag - Freitag:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            9:00 - 17:00 Uhr
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Samstag - Sonntag:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            Geschlossen
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2" color="text.secondary">
                            Feiertage:
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <Typography variant="body2">
                            Geschlossen
                          </Typography>
                        </Grid>
                      </Grid>
                      <Alert severity="info" sx={{ mt: 2 }}>
                        Außerhalb der Geschäftszeiten können Sie ein Ticket erstellen oder eine E-Mail senden. Wir werden Ihnen am nächsten Arbeitstag antworten.
                      </Alert>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            )}
            
            {/* Dokumentations-Bereich */}
            {activeTab === 3 && (
              <Box>
                <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                  Dokumentation und Ressourcen
                </Typography>
                <Typography variant="body1" paragraph color="text.secondary">
                  Hier finden Sie umfassende Dokumentationen, Handbücher und technische Ressourcen zur ARGUS-Plattform.
                </Typography>
                
                <Grid container spacing={3}>
                  {documentationData.map((doc, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                      <Card 
                        variant="outlined" 
                        sx={{ 
                          height: '100%',
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          '&:hover': {
                            transform: 'translateY(-4px)',
                            boxShadow: 3
                          }
                        }}
                      >
                        <CardContent>
                          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                            <Avatar sx={{ bgcolor: 'primary.light', mr: 2 }}>
                              {doc.icon}
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                              {doc.title}
                            </Typography>
                          </Box>
                          <Typography variant="body2" color="text.secondary" paragraph>
                            {doc.description}
                          </Typography>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                            <Chip 
                              label={`${doc.format} • ${doc.size}`} 
                              size="small" 
                              variant="outlined"
                            />
                            <Button
                              variant="text"
                              color="primary"
                              startIcon={<DownloadIcon />}
                              href={doc.url}
                            >
                              Download
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  ))}
                </Grid>
                
                <Box sx={{ mt: 4 }}>
                  <Typography variant="h6" gutterBottom sx={{ fontWeight: 600 }}>
                    Entwicklerressourcen
                  </Typography>
                  <Divider sx={{ mb: 2 }} />
                  
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <Card variant="outlined">
                        <CardContent>
                          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                            API-Referenz
                          </Typography>
                          <Typography variant="body2" color="text.secondary" paragraph>
                            Vollständige Dokumentation der ARGUS-API für Entwickler, die die Plattform in ihre eigenen Anwendungen integrieren möchten.
                          </Typography>
                          <Button
                            variant="outlined"
                            color="primary"
                            href="#"
                          >
                            Zur API-Dokumentation
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Card variant="outlined">
                        <CardContent>
                          <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600 }}>
                            Entwickler-Community
                          </Typography>
                          <Typography variant="body2" color="text.secondary" paragraph>
                            Treten Sie unserer Entwickler-Community bei, um Fragen zu stellen, Ideen auszutauschen und von anderen Entwicklern zu lernen.
                          </Typography>
                          <Button
                            variant="outlined"
                            color="primary"
                            href="#"
                          >
                            Community beitreten
                          </Button>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </Box>
                
                <Box sx={{ mt: 4, textAlign: 'center' }}>
                  <Typography variant="body1" paragraph>
                    Haben Sie nicht gefunden, wonach Sie suchen?
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setActiveTab(2)}
                  >
                    Kontaktieren Sie uns
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Paper>
      </Box>
      
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Ihr Support-Ticket wurde erfolgreich gesendet. Wir werden uns in Kürze bei Ihnen melden.
        </Alert>
      </Snackbar>
    </MainLayout>
  );
};

export default HelpSupportPage;
